import React, { useEffect, useState } from 'react';
import throttle from 'lodash-es/throttle';

import { calcBreakpoints } from './calculation';
import { DirectionType } from '../../interfaces/IBreakpoints';
import { getBreakPointNames } from './utils';

const getWidth = () => Math.max(document.documentElement.clientWidth, innerWidth);
const getHeight = () => Math.max(document.documentElement.clientHeight, innerHeight);
const getBreakpoints = () => ({
    width: calcBreakpoints(getWidth(), DirectionType.WIDTH),
    height: calcBreakpoints(getHeight(), DirectionType.HEIGHT),
});

export const BreakpointsContext = React.createContext(getBreakpoints());

export const BreakpointsProvider = ({ children }: { children: any }): JSX.Element => {
    const [breakpoints, updateBreakpoints] = useState(getBreakpoints());

    useEffect(() => {
        const handleResize = throttle(() => {
            const newBreakpoints = getBreakpoints();
            const activePoints = getBreakPointNames(breakpoints);
            const actionNewPoints = getBreakPointNames(newBreakpoints);

            if (activePoints.width !== actionNewPoints.width || activePoints.height !== actionNewPoints.height) {
                updateBreakpoints(newBreakpoints);
            }
        }, 200);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    });

    return <BreakpointsContext.Provider value={breakpoints}>
        {children}
    </BreakpointsContext.Provider>;
};
